// extracted by mini-css-extract-plugin
export default {"buttons":"frequently-asked-questions-edit_buttons__AKs0a","date":"frequently-asked-questions-edit_date__wCez9"};